export default __webpack_public_path__ + "static/media/bsi-icon.2415e180.svg";